import React, { FC, Fragment, useState } from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import "./menu.scss";
import { Typography } from "@material-ui/core";

interface SectionComponentProps {
  name: string;
}

const useStyles = makeStyles(() => ({
  menuItem: {
    whiteSpace: "normal",
    fontWeight: (isOpen: any) => (isOpen ? 700 : 500),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
}));

const SectionComponent: FC<SectionComponentProps> = ({ name, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const classes = useStyles(isOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const header = (
    <MenuItem
      onClick={handleToggle}
      className={classes.menuItem}
      disableGutters
    >
      <Typography
        variant="subtitle1"
        style={{
          padding: "6px 15px",
        }}
      >
        {name}
      </Typography>

      {isOpen ? <ExpandLess /> : <ExpandMore />}
    </MenuItem>
  );

  return (
    <Fragment>
      {isOpen ? (
        header
      ) : (
        <Tooltip title={name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default SectionComponent;
